import * as React from 'react';
import { Save } from 'react-feather';
import styled from 'styled-components';
// @ts-ignore
import { Transition } from 'react-spring';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import Loader from '../Loader';
import { theme } from '../../../theme';

import {
  SideModalCloseButton,
  SideModalBodyCont,
  SideModalFooterCont,
  SideModalHeaderCont,
  SideModalInner,
  SideModalWrap,
} from './Elements';

const SaveButton = styled(Save)<any>`
  right: 40px;
  width: 20px;
  height: 20px;
  z-index: ${theme.zIndex[13]};
  font-size: 40px;
  position: absolute;
  color: rgba(0, 0, 0, 0.6);
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  &:hover {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.9);
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

const SIDE_MODAL_ANIM_CONFIG = {
  duration: 250,
  tension: 100,
  friction: 10,
};

type SideModalProps = StyledSystemProps & {
  body?: string;
  open: boolean;
  busy?: boolean;
  heading?: string;
  actions?: React.ReactNode;
  onClick?: () => void;
  onClose: () => void;
  onExit: () => void;
  children?: JSX.Element;
};

// type ModalState = {
//   open: boolean;
// };

const SideModal: React.FC<SideModalProps> = props => {
  const { busy, onClose, onExit, ...restProps } = props;
  const hasChildren = !!props.children;
  return (
    <Transition
      items={props.open}
      native={true}
      config={SIDE_MODAL_ANIM_CONFIG}
      from={{
        opacity: 0,
        transform: 'translateX(20px)',
      }}
      enter={{
        opacity: 1,
        transform: 'translateY(0)',
      }}
      leave={{
        opacity: 0,
        transform: 'translateX(20px)',
        pointerEvents: 'none',
      }}
    >
      {(modalOpen: any) =>
        modalOpen &&
        ((styleProps: any) => (
          <SideModalWrap style={{ opacity: styleProps.opacity }}>
            <SideModalInner {...restProps} haschildren={`${hasChildren}`} style={styleProps}>
              <React.Fragment>
                <SideModalHeaderCont>
                  {props.heading}
                  {!props.busy && (
                    <React.Fragment>
                      <SaveButton
                        disabled={props.busy ? true : undefined}
                        onClick={() => {
                          onClose();
                        }}
                      />
                      <SideModalCloseButton
                        disabled={props.busy ? true : undefined}
                        onClick={() => {
                          onExit();
                        }}
                      />
                    </React.Fragment>
                  )}
                  {!!props.busy && <Loader justifyContent="right" width={20} height={20} />}
                </SideModalHeaderCont>
                <SideModalBodyCont busy={props.busy}>{props.children}</SideModalBodyCont>
                {props.actions && <SideModalFooterCont>{props.actions}</SideModalFooterCont>}
              </React.Fragment>
            </SideModalInner>
          </SideModalWrap>
        ))
      }
    </Transition>
  );
};

export default SideModal;
